import { resolution } from '@utils';

import { CryptoCurrencyEnum } from '@modules/global/types';

export type ResolveUnstoppableDomain = (
  value: string,
  currency: CryptoCurrencyEnum
) => Promise<string | undefined>;

const resolveUnstoppableDomain: ResolveUnstoppableDomain = async (value, currency) => {
  if (currency === CryptoCurrencyEnum.MATIC) {
    return resolution.multiChainAddr(value, currency, 'MATIC'); // https://mercuryo.atlassian.net/browse/MRC-26181
  }
  return resolution.addr(value, currency);
};

export default resolveUnstoppableDomain;
